import React, { useEffect } from 'react'
import registerAnimations from './registerAnimations'
import TrustpilotWidget from '../TrustpilotWidget/TrustpilotWidget'
import footbedImage from '../../static/images/slippers/footbed.png'
import quoteImage from '../../static/images/quote.png'


const LandingPageSlippers2 = ({
  sec4ImageMobile,
  sec4Image,
  sec4Text1,
  sec4Text2,
  sec4Button1Url,
  sec4Button1Text,
  sec4Button2Text,
  sec5ImageMobile,
  sec5Image,
  sec5Text1,
  sec5Text2,
  sec5Button1Url,
  sec5Button1Text,
  sec5Button2Text,
  sec6ImageMobile,
  sec6Image,
  sec6Text1,
  sec6Text2,
  sec6Button1Url,
  sec6Button1Text,
  sec7Text1,
  sec7Image1,
  sec7Button1Url,
  sec7Button1Text,
  sec7Image2,
  sec7Button2Url,
  sec7Button2Text,
  sec7Image3,
  sec7Button3Url,
  sec7Button3Text,
  testimonialsImage,
  testimonialsText,
  testimonialsButton1Url,
  testimonialsButton1Text,
  testimonialsButton2Url,
  testimonialsButton2Text,
}) => {
  useEffect(() => {
    registerAnimations()
  }, [])

  return (
    <div className="landingpage-slippers">

      <style>
        {`
          .sec4 {
            background-image: url(${sec4ImageMobile}); 
          }

          @media (min-width: 768px) {
            .sec4 {
              background-image: url(${sec4Image});
            }
          }
        `}
      </style>
      <section className="sec sec4 d-flex">
        <div className="container d-flex flex-grow-1">
          <div className="row flex-grow-1">
            <article className="content col-12 col-sm- col-md-7 col-lg-6 col-xl-5 mr-auto align-self-center">
              <h2>{sec4Text1}</h2>
              <p className="pr-xl-5">{sec4Text2}</p>
              <p className="pt-4  mb-0">
                <a href={sec4Button1Url} className="btn btn-outline-light  mb-1 mr-2 btn-size-md">{sec4Button1Text}</a>
                <a href="#configure" className="btn btn-outline-light mb-1 ml-2 btn-size-md">{sec4Button2Text}</a>
              </p>
            </article>
          </div>
        </div>
      </section> 

      <style>
        {`
          .sec5 {
            background-image: url(${sec5ImageMobile}); 
          }

          @media (min-width: 768px) {
            .sec5 {
              background-image: url(${sec5Image});
            }
          }
        `}
      </style>
      <section className="sec sec5 d-flex">
        <div className="container d-flex flex-grow-1">
          <div className="row  flex-grow-1">
            <article className="content col-10 col-sm- col-md-7 col-lg-6 col-xl-5 ml-auto text-right align-self-center">
              <h2 className="pl-5 pl-md-0 ml-4 ml-md-5 ml-lg-4 ml-xl-2">{sec5Text1}</h2>
              <div className="pl-5 pl-md-0 ml-4 ml-md-5 ml-lg-4 ml-xl-2">{sec5Text2}</div>
              <div className="d-none d-md-flex text-center text-md-right btn-group pt-4 mb-0 d-md-block ">
                <a href={sec5Button1Url} className="btn btn-dark mb-1 mr-2 btn-size-md">{sec5Button1Text}</a>
                <a href="#configure" className="btn btn-dark mb-1 ml-2 btn-size-md">{sec5Button2Text}</a>
              </div>
            </article>
            <article className="content d-md-none col-112 col-sm- col-md-7 col-lg-6 col-xl-5 ml-auto text-right align-self-center">
              <p className="d-flex text-center text-md-right btn-group pt-5 mt-5 mb-0 d-md-block ">
                <a href={sec5Button1Url} className="btn btn-dark mb-1 mr-2 btn-size-md">{sec5Button1Text}</a>
                <a href="#configure" className="btn btn-dark mb-1 ml-2 btn-size-md">{sec5Button2Text}</a>
              </p>
            </article>
          </div>
        </div>
      </section> 
      
      <style>
        {`
          .sec6 {
            background-image: url(${sec6ImageMobile}); 
          }

          @media (min-width: 768px) {
            .sec6 {
              background-image: url(${sec6Image});
            }
          }
        `}
      </style>
      <section className="sec sec6 footbed bg-dark d-flex position-relative">
        <div className="container d-flex flex-grow-1 position-static ">
          <div className="row flex-grow-1">
            <article className="content-2 col-12 col-md-6 col-lg-6 col-xl-5 pt-lg-4 mr-md-auto align-self-center">
              <h2>{sec6Text1}</h2>
              <p className="mr-xl-4">{sec6Text2}</p>
              <p className="btn-group pt-4 mb-0">
                <a href={sec6Button1Url} className="btn btn-dark mb-1 btn-size-md">{sec6Button1Text}</a> 
              </p>
            </article> 
            <figure className="col-12 col-md-6  align-self-center position-static">
              <p className="hide animated fadeInLeft">
                <img src={footbedImage} alt="" className="d-md-block footbed-img hide animated" /> 
              </p>
            </figure>
          </div> 
        </div>
      </section>

      <section className="sec sec7 d-flex position-relative text-center">
        <div className="container">
          <h2>{sec7Text1}</h2>
          <div className="row">
            <article className="col-12 col-md-4 mb-4">
              <figure className="mb-0"><img src={sec7Image1} alt="" /></figure>
              <p><a href={sec7Button1Url} className="btn btn-dark">{sec7Button1Text}</a></p>
            </article>
            <article className="col-12 col-md-4 mb-4">
              <figure className="mb-0"><img src={sec7Image2} alt="" /></figure>
              <p><a href={sec7Button2Url} className="btn btn-dark">{sec7Button2Text}</a></p>
            </article>
            <article className="col-12 col-md-4 mb-4">
              <figure className="mb-0"><img src={sec7Image3} alt="" /></figure>
              <p><a href={sec7Button3Url} className="btn btn-dark">{sec7Button3Text}</a></p>
            </article>
          </div>
        </div>
      </section>
      <section className="sec sec10 py-5 testimonials">
        <div className="container">
          <p className="text-center qoute pb-4"><img src={quoteImage} alt="" /></p>
        </div>
        <div className="trustBox-widget py-4 py-lg-5 mb-5">
          <div className="container">
            <TrustpilotWidget />
          </div>
        </div>
        <div className="testimonials-products">
          <div className="container">
            <div className="row">
              <figure className="d-none d-md-block col-12 col-md-5">
                <p><img src={testimonialsImage} alt="" /></p>
              </figure>
              <article className="content col-12 col-md-7 mb-lg-0 ml-md-auto">
                <h3>{testimonialsText}</h3>
                <figure className="d-md-none"><img src={testimonialsImage} alt="" /></figure>
                <p className="btn-cont mt-4 pt-1 text-center text-md-left">
                  <a href={testimonialsButton1Url} className="btn btn-dark  d-md-inline-block mb-3">{testimonialsButton1Text}</a>
                  <a href={testimonialsButton2Url} className="btn btn-dark  d-md-inline-block mb-3 ml-sm-3">{testimonialsButton2Text}</a>
                </p>
              </article>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

LandingPageSlippers2.defaultProps = {}

export default LandingPageSlippers2
